// extracted by mini-css-extract-plugin
export var searchHeader = "_99-0";
export var searchHeaderDark = "_99-1";